exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#whatsapp[data-v-7e0fc944]{position:fixed;display:flex;justify-content:center;align-items:center;bottom:6%;right:5%;background-color:#25d366;color:#fff;padding:8px;width:50px;height:50px;border-radius:50%;z-index:999;cursor:pointer}.hidden[data-v-7e0fc944]{display:none}.visible[data-v-7e0fc944]{display:block}.tlfs[data-v-7e0fc944]{position:fixed;width:175px;visibility:none;right:0;text-align:center;font-size:12px;font-weight:700;background-color:#25d366;color:#fff;padding:8px;z-index:500;border-radius:8px;cursor:pointer}#tlf1[data-v-7e0fc944]{bottom:13%}#tlf2[data-v-7e0fc944]{bottom:18%}#tlf3[data-v-7e0fc944]{bottom:23%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e0fc944","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Whatsapp.vue
// module id = 457
// module chunks = 2